<template>
<div class="layout" :class="{'layout-hide-text': spanLeft < 4}" style="min-width:1280px">
    <Row type="flex" style="flex-wrap:nowrap">
        <Col :span="spanLeft" class="layout-menu-left" id="menuLeft">
        <Menu ref="slideMenu" :active-name="active" theme="dark" width="auto" accordion id="menuTitle">
            <div class="layout-logo-left" id="title"> 小 罐 茶 </div>
            <router-link to='/Information'>
                <MenuItem name="1">
                <Icon type="ios-paper" />
                <span class="layout-text">推送消息设置</span>
                </MenuItem>
            </router-link>
            <router-link to='/WelcomeSitting'>
                <MenuItem name="2">
                <Icon type="ios-people" />
                <span class="layout-text">欢迎词设置</span>
                </MenuItem>
            </router-link>
             <router-link to='/KeywordsSittings'>
                <MenuItem name="3">
                <Icon type="ios-people" />
                <span class="layout-text">关键词设置</span>
                </MenuItem>
            </router-link>
        </Menu>
        </Col>
        <Col :span="spanRight" style="overflow-y:auto;">
        <div class="layout-header">
            <div id="person">
                <span style="padding:0 10px 0 10px;cursor: pointer;" @click="exit()">退出登录</span>
                <span @click="exit()" id="exit">
                    <Icon type="md-power" style="margin:0 20px 0 0" size="18"></Icon>
                </span>
            </div>
        </div>
        <div class="layout-breadcrumb">
        </div>
        <div class="layout-content">
            <h1 v-if="$route.matched.length === 1" style="text-align:center;margin-top:0px;margin-bottom:30px;" class="animated zoomIn welcomeText">
                <i>
                    欢 迎 来 到 小 罐 茶 后 台 管 理 系 统
                </i>
            </h1>
            <!-- <Card :dis-hover="true" class="category" v-if="$route.matched.length === 1" v-for="(item, index) in moduleList" :key="index">
          <div class="category-title" v-text="item.type"></div>
          <div class="module-wrap">
            <Card :padding="10" :bordered="false" class="module-container" v-for="(cItem, cIndex) in item.data" :key="cIndex">
              <div class="module-content" :style="{backgroundImage: 'url(' + cItem.icon + ')'}"></div>
              <div class="module-title" v-text="cItem.name"></div>
            </Card>
          </div>
        </Card> -->
            <keep-alive>
                <router-view v-if="$route.meta.keepAlive"></router-view>
            </keep-alive>
            <router-view v-if="!$route.meta.keepAlive"></router-view>
        </div>
        <!-- <div class="layout-copy">
          2014-2017 &copy; 杭州小仙科技
      </div> -->
        </Col>
    </Row>
</div>
</template>

<script>
export default {
    data() {
        return {
            active: 1,
            spanLeft: 4,
            spanRight: 20,
            currentName: '',
            openName: [
                this.$route.matched.length === 1 ?
                this.$route.matched[0].name :
                this.$route.matched[1].name || this.$route.matched[1].meta.name
            ]
            // moduleList: []
        }
    },
     // 监听,当路由发生变化的时候执行
        watch: {
            $route(to, from) {
              if(to.path == '/WelcomeSitting') {
                sessionStorage.setItem('active', 2)
              }else if(to.path == '/Information') {
                sessionStorage.setItem('active', 1)
              }else if(to.path == '/KeywordsSittings') {
                sessionStorage.setItem('active', 3)
              }
              console.log( this.active)
            }
        },
    computed: {
       
        iconSize() {
            return this.spanLeft === 4 ? 14 : 30
        }
    },
    methods: {
        toggleClick() {
            if (this.spanLeft === 4) {
                this.spanLeft = 1
                this.spanRight = 23
                document.getElementById('menuLeft').style.minWidth = '140px'
                document.getElementById('menuBtn').style.transform = 'rotate(-90deg)'
                document.getElementById('title').innerHTML =
                    '<span ><i style="color:transparent">PL</i>  小罐茶  <i style="color:transparent">PL</i></span>'
            } else {
                this.spanLeft = 4
                this.spanRight = 20
                document.getElementById('menuLeft').style.minWidth = '160px'
                document.getElementById('menuBtn').style.transform = 'rotate(0deg)'
                document.getElementById('title').innerText = '  小罐茶  '
            }
        },
        // 返回主页
        home() {
            this.$router.push({
                path: '/'
            })
            document.title = '  小罐茶  '
        },
        // 退出登录
        exit() {
            this.$router.push({
                path: '/BackLogin'
            })
            document.title = '  小罐茶  '
        },
    },
    created() {
      this.active = sessionStorage.getItem('active')
      console.log(this.active)
    }
}
</script>

<style scoped>
.ivu-btn-text:focus {
    box-shadow: none;
}

.layout {
    border: 1px solid #d7dde4;
    background: #f5f7f9;
    position: relative;
    border-radius: 4px;
    overflow: hidden;
}

.layout-breadcrumb {
    padding: 10px 15px 0;
}

.layout-content {
    /* padding: 10px; */
    min-height: 200px;
    margin: 15px;
    overflow: hidden;
    /* background: #fff; */
    border-radius: 4px;
}

.layout-content-main {
    padding: 10px;
}

.layout-copy {
    text-align: center;
    padding: 10px 0 20px;
    color: #9ea7b4;
    position: absolute;
    width: 100%;
    bottom: 0;
}

.layout-menu-left {
    background: #464c5b;
    min-width: 140px;
}

.layout-header {
    height: 60px;
    background: #fff;
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
}

.layout-logo-left {
    width: 90%;
    height: 30px;
    line-height: 30px;
    text-align: center;
    background: #5b6270;
    border-radius: 3px;
    margin: 15px auto;
    color: #fff;
    font-weight: bold;
    font-size: 20px;
    cursor: pointer;
}

.layout-ceiling-main a {
    color: #9ba7b5;
}

.layout-hide-text .layout-text {
    display: none;
}

.ivu-col {
    transition: width 0.2s ease-in-out;
}

#person {
    float: right;
    height: 100%;
    display: flex;
    display: -webkit-flex;
    align-items: center;
}

#exit {
    cursor: pointer;
}

.welcomeText {
    color: #dc2829;
    background-image: -webkit-linear-gradient(92deg, #f21c11, #f65951);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

#menuBtn {
    height: 100%;
}
</style>
